import { jsxs as e, jsx as C } from "react/jsx-runtime";
function o(r) {
  return /* @__PURE__ */ e("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M12.5303 8.71975C12.2373 8.42675 11.7627 8.42675 11.4698 8.71975L7.2198 12.9697C6.9268 13.2627 6.9268 13.7374 7.2198 14.0303C7.3663 14.1768 7.5577 14.25 7.7501 14.25C7.9425 14.25 8.1339 14.1768 8.2804 14.0303L12.0001 10.3106L15.7198 14.0303C15.8663 14.1768 16.0577 14.25 16.2501 14.25C16.4425 14.25 16.6339 14.1768 16.7804 14.0303C17.0734 13.7373 17.0734 13.2626 16.7804 12.9697L12.5303 8.71975Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M12 2C6.4863 2 2 6.4858 2 12C2 17.5142 6.4863 22 12 22C17.5137 22 22 17.5142 22 12C22 6.4858 17.5137 2 12 2ZM12 20C7.5889 20 4 16.4111 4 12C4 7.5889 7.5889 4 12 4C16.4111 4 20 7.5889 20 12C20 16.4111 16.4111 20 12 20Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  o as default
};
